// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linesHeaderStyles } from "@pace/App/Components/Cart/LinesHeader";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, getSystemColor, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        ${({ isCondensed }: any) =>
            !isCondensed
                ? `grid-template-columns: 91px minmax(0, 267px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(0, 135px) minmax(
                0,
                12px
            )`
                : ` grid-template-columns: minmax(0, 288px) minmax(0, 213px) minmax(0, 135px) minmax(0, 123px) minmax(0, 149px) minmax(
                0,
                12px
            );
            border-radius: 4px 4px 0 0;`};

        grid-column-gap: 12px;
        grid-auto-flow: column;

        font-size: 12px;
        line-height: 20px;
        color: ${color("common.ui6")};
        font-weight: ${fontConfig.weight.bold};

        width: 100%;
        background: ${color("common.ui11")};
        ${({ isCondensed }: any) =>
            !isCondensed
                ? `border: 1px solid ${getSystemColor("common.ui12")}; border-radius: 4px`
                : `border-bottom: 1px solid ${getSystemColor("common.ui12")}`};
        padding: 0 12px;

        ${xScreen("lte", "md")} {
            display: none;
        }

        @media print {
            color: ${getSystemColor("common.white")};
            background: ${getSystemColor("primary")};
            ${({ isCondensed }: any) =>
                isCondensed
                    ? `
                    &&& {
                        display: grid;
                    }`
                    : `
                    display: none;
                `};
        }
    `,
};
linesHeaderStyles.itemDescription = {
    css: css`
        padding: 8px 0;
        border-right: 1px solid ${color("common.ui12")};
        ${({ isCondensed }: any) => (!isCondensed ? "grid-column: 1 / 3" : "grid-column: 1 / 2")};
        ${xScreen("lte", "md")} {
            grid-column: 1 / 6;
        }
    `,
};
linesHeaderStyles.availability = {
    css: css`
        border-right: 1px solid ${color("common.ui12")};
        padding: 8px 0;
        ${({ isCondensed }: any) => (!isCondensed ? "grid-column: 3 / 4" : "grid-column: 2 / 3")};
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.priceUnit = {
    css: css`
        border-right: 1px solid ${color("common.ui12")};
        padding: 8px 0;
        ${({ isCondensed }: any) => (!isCondensed ? "grid-column: 4 / 5" : "grid-column: 3 / 4")};
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.qty = {
    css: css`
        border-right: 1px solid ${color("common.ui12")};
        padding: 8px 0;
        ${({ isCondensed }: any) => (!isCondensed ? "grid-column: 5 / 6" : "grid-column: 4 / 5")};
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.total = {
    css: css`
        border-right: 1px solid ${color("common.ui12")};
        padding: 8px 0;
        ${({ isCondensed }: any) => (!isCondensed ? "grid-column: 6 / 7" : "grid-column: 5 / 6")};
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
